import React, {useEffect, useState} from "react";
import styles from "../../css/community-detailed.module.css";
import noAnswerIcon from "../../../../public/images/question_answer_grey.svg";
import copyLinkIcon from "../../../../public/images/copyLinkIcon.svg";
import verifiedMobile from "../../../../public/images/verified-badge.svg";
import ActionButtonContainer from "../../../shared/containers/ActionButtonContainer";
import editIcon from "../../../../public/images/edit_white.svg";
import deleteIcon from "../../../../public/images/delete_white.svg";
import {getDate} from "../../../app/dashboard/utils/get-date";
import {getColor} from "../../../shared/utils/getColor";
import PopUpContainer from "../../../shared/components/PopUpContainer";
import AddEditAnswerPopUp from "./CommunityPopUps/AddEditAnswerPopUp";
import {useSelector} from "react-redux";
import {useCommunityDelete} from "./CommunityCustomHooks/useCommunityDelete";
import ModalDialog from "../../../shared/components/ModalDialog";
import {PAGE_HASH_LOCATION} from "../../../app/utils/pages";
import MaterialCheckBox from "../../../shared/components/MaterialCheckBox";
import backArrow from "../../../../public/images/arrow_back_black.svg";
import copylink from "../../../../public/images/icons/CopyLinkIcon.svg";
import editIconMobile from "../../../../public/images/icons/community-edit-icon.svg";
import deleteIconMobile from "../../../../public/images/icons/community-delete-icon.svg";
import SurveyHeartLogo from "../../../../public/images/surveyheart_grey.svg";
import backRounded from "../../../../public/images/back_rounded.svg"
import {isMobileOnly} from "react-device-detect";
import {deleteAnswer, verifyAnswer} from "../../../shared/utils/sash-v2-api";
import {getAdminUserRole, validateAdminUser} from "../../../admin/utils/admin-api-services/user-api-services";
import Paginator from "../../../shared/components/Paginator";
import {addToHistory, setRole, setUserId} from "../../../admin/utils/admin-api-services/history-api-services";
import style from "../../css/community.module.css";
import MobileRedirectToApp from "../../../app/dashboard/components/MobileRedirectToApp";
import blankProfile from "../../../../public/images/avatar.png";


const CommunityThreadDetailed = (props) => {
    const [copyStatus, setCopyStatus] = useState("Copy Link");
    const [addAnswerPopUp, setAddAnswerPopUp] = useState(false);
    const [answerToEdit, setAnswerToEdit] = useState(null);
    const [answerId, setAnswerId] = useState(null);
    const [currentThreadId, setCurrentThreadId] = useState(null);
    const userId = useSelector((state) => state.userReducer.userId);
    const [isAdminUser, setIsAdminUser] = useState(null);
    const [roleAdmin, setRoleAdmin] = useState(null);
    const {answers = [], question, answers_count} = props?.thread;
    const [copiedLink, setCopiedLink] = useState(false);
    const admin = ['admin', 'super_admin']
    const [redirectToApp, setRedirectToApp] = useState(false);
    const {deletePopUp, answerToDelete, handleCommunityDeletePopUp, handleCommunityDeletePopUpClose} = useCommunityDelete();
    const QUESTIONS_PER_PAGE = 50

    const handleBackNavigationArrow = () => {
        props.setSelectedThread(null);
        window.location.href = window.location.origin + PAGE_HASH_LOCATION.community;
    };

    useEffect(() => {
        if (userId) {
            const successFunction = (res) => {
                if (res && res.result) {
                    setIsAdminUser(res.result.is_admin_user)
                }
            }
            const failureFunction = (err) => {
                console.error(err)
            }
            validateAdminUser(userId, successFunction, failureFunction)
        }
    }, []);

    useEffect(() => {
        if (isAdminUser && userId) {
            const successFunction = (res) => {
                if (admin.includes(res.role)) {
                    setRoleAdmin(res.role);
                }
            };
            const failureFunction = (err) => {
                console.log(err);
            };
            getAdminUserRole(userId, successFunction, failureFunction);
        }
    }, [isAdminUser, userId]);


    const handleAnswerPopUp = (answerId, threadId, answer) => {
        if (!userId) {
            localStorage.setItem("isCommunity", true);
            window.location = "/app" + PAGE_HASH_LOCATION.login;
        } else {
            setAnswerId(answerId);
            setAnswerToEdit(answer);
            setCurrentThreadId(threadId);
            setAddAnswerPopUp(true);
        }
    };


    const handleDeleteAnswer = () => {
        if (answerToDelete) {
            const answerId = answerToDelete;
            const id = answerId;
            const successFunction = () => {
                const updatedAnswers = answers.filter((answer) => answer._id !== answerId);
                let updatedQuestionData;
                if (props?.thread) {
                    updatedQuestionData = {
                        ...props.thread, answers: updatedAnswers, answers_count: answers_count - 1,
                    };
                    props.setSelectedThread(updatedQuestionData);

                }
                handleCommunityDeletePopUpClose();
            };

            const failureFunction = (error) => {
                console.error("Failed to delete thread:", error);
                handleCommunityDeletePopUpClose();
            };

            deleteAnswer(id, successFunction, failureFunction);
        } else {
            handleCommunityDeletePopUpClose();
        }
    };


    const closePopUp = () => {
        setAddAnswerPopUp(false);
        setAnswerToEdit(null);
        setCurrentThreadId(null);
    };

    const handleCopyLink = (threadId) => {
        const link = `${window.location.origin}/#community/?id=${threadId}`;
        navigator.clipboard
            .writeText(link)
            .then(() => {
                setCopiedLink(threadId)
                setCopyStatus("Link Copied");
                setTimeout(() => {
                    setCopiedLink(null)
                    setCopyStatus("Copy Link");
                }, 2000);
            })
            .catch((error) => {
                console.error("Failed to copy text: ", error);
            });
    };

    const handleVerifyChange = (checked, answerId) => {
        const successFunction = () => {
            const updatedAnswers = props?.thread?.answers?.map((answer) => {
                if (answer._id === answerId) {
                    setUserId(userId);
                    setRole(roleAdmin);
                    const actionMessage = checked ? 'Community Answer Verified' : 'Community Answer Unverified';
                    addToHistory(actionMessage, `community answerId=${answerId}`);
                    return {...answer, isVerified: checked};
                }
                return answer;
            });
            const updatedThread = props?.thread ? {...props.thread, answers: updatedAnswers} : props.thread;
            props.setSelectedThread(updatedThread);
        };
        const failureFunction = (error) => {
            console.error("Error updating answer verification:", error);
        };
        verifyAnswer(answerId, successFunction, failureFunction);
    };

    const communityHome = () => {
        props.setSelectedThread(null)
        window.location.href = window.location.origin + PAGE_HASH_LOCATION.community;
    }

    const redirectToMobileScreen = () => {
        setRedirectToApp(true)
    }

    const signOutPopUp = () => {
        localStorage.setItem('communitySignOut', true)
        window.location = window.location.origin + '/app?u=0' + PAGE_HASH_LOCATION.dashboard
    }

    return (<>
            {!isMobileOnly ? <>
                <div style={{backgroundColor: '#F5F5F5', minHeight: '100vh', margin: '0'}}>
                    {userId && <div
                        onClick={signOutPopUp}
                        className={style.communityAccount}
                        style={{
                            backgroundColor: getColor(userId[0]), position: 'absolute', right: '85px', top: '20px'
                        }}
                    >
                        {userId[0].toUpperCase()}
                    </div>}
                    <div style={{padding: "20px 230px"}} className={styles.detailedContainer}>
                        <div style={{
                            display: "flex", justifyContent: "space-between", alignItems: "center", minWidth: '1020px'
                        }}>
                            <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                <img style={{cursor: 'pointer'}} onClick={communityHome} src={backRounded}
                                     alt='back' height={35}/>
                                <p style={{color: "black"}} className={styles.questionTitle}>
                                    {question?.title}
                                </p>
                            </div>
                            <div className={styles.copyLinkButton}
                                 onClick={() => handleCopyLink(question?._id)}>
                                <img width={15} src={copyLinkIcon} alt="copy"/>
                                {copyStatus}
                            </div>
                        </div>
                        <p className={styles.description}>{question?.description}</p>
                        <ActionButtonContainer
                            buttonText={"+Add Answer"}
                            handleClick={() => {
                                handleAnswerPopUp(null, question?._id, null);
                            }}
                            fontSize="14px"
                            buttonWidth="120px"
                            height="35px"
                        />
                        <p className={styles.answerLength}>Answers ({answers_count})</p>

                        {answers_count === 0 ? (<div className={styles.noAnswersMessage}>
                                <img height={100} src={noAnswerIcon} alt="noAnswerIcon"/>
                                <p style={{margin: "0"}}>No Answers received yet</p>
                            </div>) : (<div className={styles.answers}>
                                {answers.map((answer) => (<div key={answer._id} className={styles.answerCard}>
                                        <div>
                                            <div className={styles.leftHeader}>
                                                {userId !== answer.user_id ? (<div className={styles.communityAvatar}
                                                                                   style={{backgroundColor: getColor(answer.user_id[0])}}>
                                                        <span>{answer.user_id[0].toUpperCase()}</span>
                                                    </div>) : (<>
                                                        <div style={{justifyContent: "space-between"}}
                                                             className={styles.userInfo}>
                                                            <div className={styles.dateContainer}>
                                                                <p className={styles.communityDate}>
                                                                    {getDate(answer.answerd_at)}
                                                                </p>
                                                                <div className={styles.editDeleteButtons}>
                                                                    <div
                                                                        onClick={() => handleAnswerPopUp(answer._id, answer.question_id, answer.community_answer)}
                                                                        className={styles.editButton}>
                                                                        <div style={{display: "flex"}}>
                                                                            <img height={12} src={editIcon}
                                                                                 alt="edit"/>
                                                                            <span>Edit</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className={styles.deleteButton}
                                                                         onClick={() => handleCommunityDeletePopUp(answer._id, answer.question_id)}>
                                                                        <div style={{display: "flex"}}>
                                                                            <img height={12} src={deleteIcon}
                                                                                 alt="delete"/>
                                                                            <span>Delete</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style={{position: "absolute", right: "10px"}}>
                                                            {roleAdmin ? (<div style={{
                                                                    display: "flex", alignItems: "center", gap: "8px"
                                                                }}>
                                                        <span>
                                                            {answer.isVerified ? "Verified" : "Verify"}
                                                        </span>
                                                                    <MaterialCheckBox
                                                                        isChecked={answer.isVerified}
                                                                        onChange={(checked) => handleVerifyChange(checked, answer._id, answer.question_id)}
                                                                    />
                                                                </div>) : (answer.isVerified && (
                                                                    <img height={30} src={verifiedMobile}
                                                                         alt="verified"/>))}
                                                        </div>
                                                    </>)}
                                                {userId !== answer.user_id && (<>
                                                        <div className={styles.userInfo}>
                                                            <p style={{margin: "5px 0"}}
                                                               className={styles.userName}>
                                                                {answer.user_id.split("@")[0]}
                                                            </p>
                                                            <p style={{margin: "5px 0"}}
                                                               className={styles.communityDate}>
                                                                {getDate(answer.answerd_at)}
                                                            </p>
                                                        </div>
                                                        <div style={{position: "absolute", right: "10px"}}>
                                                            {roleAdmin ? (<div style={{
                                                                    display: "flex", alignItems: "center", gap: "8px"
                                                                }}>
                                                        <span>
                                                            {answer.isVerified ? "Verified" : "Verify"}
                                                        </span>
                                                                    <MaterialCheckBox
                                                                        isChecked={answer.isVerified}
                                                                        onChange={(checked) => handleVerifyChange(checked, answer._id, answer.question_id)}
                                                                    />
                                                                </div>) : (answer.isVerified && (
                                                                    <img height={30} src={verifiedMobile}
                                                                         alt="verified"/>))}
                                                        </div>
                                                    </>)}
                                            </div>
                                            <div className={styles.answer}>
                                                {answer.community_answer.split("\n").length > 0 ? answer.community_answer.split("\n").map((line, index) => (
                                                    <p style={{fontSize: "14px"}} key={index}>{line}</p>)) : (
                                                    <p style={{fontSize: "14px"}}>{answer.community_answer}</p>)}
                                            </div>
                                        </div>
                                    </div>))}
                            </div>)}
                        {addAnswerPopUp && (<PopUpContainer>
                                <AddEditAnswerPopUp
                                    selectedAnswer={answerToEdit}
                                    selectedAnswerId={answerId}
                                    onClose={closePopUp}
                                    threadId={currentThreadId}
                                    setSelectedThread={props.setSelectedThread}
                                    answers={props?.thread}
                                />
                            </PopUpContainer>)}
                        {deletePopUp && (<ModalDialog
                                header={"DELETE"}
                                body={<p>Are you sure you want to delete your Answer?</p>}
                                buttons={[{
                                    text: "CANCEL", action: handleCommunityDeletePopUpClose,
                                }, {
                                    text: "DELETE", action: handleDeleteAnswer,
                                },]}
                            />)}
                    </div>
                </div>
                <div style={{position: "absolute", bottom: '15px'}}>
                    <Paginator handlePageChange={props.handlePageChange} initialPage={0}
                               totalPageCount={Math.abs(answers_count / QUESTIONS_PER_PAGE)}
                               containerClassName={'community-page'}
                    />
                </div>
            </> : <>
                {!redirectToApp ? <>
                    <div className={styles.detailedThreadContainer}>
                        <div>
                            <img
                                className={styles.backArrow}
                                src={backArrow}
                                alt="Back Arrow"
                                onClick={handleBackNavigationArrow}
                            />
                            <img className={styles.SHlogo} src={SurveyHeartLogo} alt="SurveyHeart"/>
                            {userId ? <div
                                onClick={redirectToMobileScreen}
                                className={style.communityAccount}
                                style={{
                                    backgroundColor: getColor(userId[0]),
                                    position: 'absolute',
                                    right: '20px',
                                    top: '12px'
                                }}
                            >
                                {userId[0].toUpperCase()}
                            </div> : <div onClick={handleAnswerPopUp}
                                          style={{position: 'absolute', right: '25px', top: '18px'}}>
                                <img src={blankProfile} height={30} alt={'profile'}/>
                            </div>}
                        </div>

                        <div className={styles.questionContainer}>
                            <h1 className={styles.questionTitle}>{question?.title}</h1>
                            <span className={styles.shareIcon}>
          {                 copiedLink ? (<span className={styles.copiedText}>Copied!</span>) : (
                            <img onClick={() => handleCopyLink(question?._id)} src={copylink} alt="Copy link"/>)}
                            </span>
                        </div>
                        <p>{question?.description}</p>
                        <ActionButtonContainer
                            buttonText={"+ Add Answer"}
                            fontSize={"18px"}
                            buttonWidth={"160px"}
                            handleClick={() => {
                                handleAnswerPopUp(null, question?._id, null);
                            }}
                        />
                        <div className={styles.answersSection}>
                            <h2 className={styles.answerLength}>Answers ({answers_count})</h2>
                            {answers_count > 0 ? (answers.map((answer) => (
                                    <div key={answer.id} className={styles.answer}>
                                        {/* Non-signed-in user header */}
                                        {userId !== answer.user_id && (<div style={{
                                                display: "flex", justifyContent: "space-between"
                                            }}>
                                                <div style={{display: "flex", gap: "7px"}}>
                                                    <div
                                                        className={styles.communityAvatar}
                                                        style={{
                                                            backgroundColor: getColor(answer.user_id[0]),
                                                        }}
                                                    >
                                                        {answer.user_id[0].toUpperCase()}
                                                    </div>
                                                    <div className={styles.userInfo}>
                                                        <div style={{
                                                            display: "flex", flexDirection: "column"
                                                        }}>
                        <span className={styles.userName}>
                          {answer.user_id.split("@")[0]}
                        </span>
                                                            <span className={styles.createdDate}>
                          {getDate(answer.answerd_at)}
                        </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    {answer.isVerified && !roleAdmin && (
                                                        <img height={35} src={verifiedMobile}
                                                             alt="verified"/>)}
                                                </div>
                                            </div>)}

                                        {/* Signed-in user header */}
                                        {userId === answer.user_id && !roleAdmin && (<div style={{
                                                display: "flex", justifyContent: "space-between"
                                            }}>
                                                <div style={{display: "flex", gap: "8px"}}>
                    <span className={styles.createdDate}>
                      {getDate(answer.answerd_at)}
                    </span>
                                                    <div
                                                        onClick={() => handleAnswerPopUp(answer._id, question?._id, answer.community_answer)}>
                                                        <img src={editIconMobile} alt="Edit"/>
                                                    </div>
                                                    <div
                                                        onClick={() => handleCommunityDeletePopUp(answer._id, answer.question_id)}>
                                                        <img src={deleteIconMobile} alt="Delete"/>
                                                    </div>
                                                </div>
                                                <div>
                                                    {answer.isVerified && !roleAdmin && (
                                                        <img height={35} src={verifiedMobile}
                                                             alt="verified"/>)}
                                                </div>
                                            </div>)}

                                        {/* Admin header */}
                                        {roleAdmin && (<div style={{
                                                display: "flex", justifyContent: "space-between"
                                            }}>
                                                {userId === answer.user_id && roleAdmin && (
                                                    <div style={{display: "flex", gap: "8px"}}>
                      <span className={styles.createdDate}>
                        {getDate(answer.answerd_at)}
                      </span>
                                                        <div
                                                            onClick={() => handleAnswerPopUp(answer._id, question?._id, answer.community_answer)}>
                                                            <img src={editIcon} alt="Edit"/>
                                                        </div>
                                                        <div
                                                            onClick={() => handleCommunityDeletePopUp(answer._id, answer.question_id)}>
                                                            <img src={deleteIcon} alt="Delete"/>
                                                        </div>
                                                    </div>)}
                                                <div
                                                    style={{
                                                        position: "absolute", right: "10px", top: "10px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex", alignItems: "center", gap: "8px",
                                                        }}
                                                    >
                      <span>
                        {answer.isVerified ? "Verified" : "Verify"}
                      </span>
                                                        <MaterialCheckBox
                                                            isChecked={answer.isVerified}
                                                            onChange={(checked) => handleVerifyChange(checked, answer._id, question?._id)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>)}

                                        <p>{answer.community_answer}</p>
                                    </div>))) : (<p>No answers available.</p>)}
                        </div>

                        {/* Add/Edit Answer Pop-Up */}
                        {addAnswerPopUp && (<PopUpContainer>
                                <AddEditAnswerPopUp
                                    selectedAnswer={answerToEdit}
                                    selectedAnswerId={answerId}
                                    onClose={closePopUp}
                                    threadId={currentThreadId}
                                    setSelectedThread={props.setSelectedThread}
                                    answers={props?.thread}
                                />
                            </PopUpContainer>)}

                        {/* Delete Confirmation Pop-Up */}
                        {deletePopUp && (<ModalDialog
                                header="Delete Answer"
                                body="Are you sure you want to delete this answer?"
                                buttons={[{text: "Cancel", action: handleCommunityDeletePopUpClose}, {
                                    text: "Delete",
                                    action: handleDeleteAnswer
                                },]}
                            />)}
                    </div>
                    <div>
                        <Paginator handlePageChange={props.handlePageChange} initialPage={0}
                                   totalPageCount={Math.abs(answers_count / QUESTIONS_PER_PAGE)}
                                   containerClassName={'community-page'}
                        />
                    </div>
                </> : <MobileRedirectToApp/>}
            </>}
        </>

    );
};

export default CommunityThreadDetailed;
